// extracted by mini-css-extract-plugin
export default {"SchedulePaymentsBlockLoader":"Z0Gzlbh_2hL_pirgRMWw"};